<div class="markup-container d-flex">
  <div class="markup-selector">
    @for (option of options; track option) {
      <div class="radio-option" (click)="selectOption($event, option)">
        <span class="radio-icon">
          @if (selectedOption?.toString() === option?.value?.toString()) {
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="19"
                height="19"
                rx="9.5"
                fill="white"
                stroke="#7E47C5"
              />
              <circle cx="10" cy="10" r="6" fill="#7E47C5" />
            </svg>
          }
          @if (selectedOption?.toString() !== option?.value?.toString()) {
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="19"
                height="19"
                rx="9.5"
                fill="white"
                stroke="#C0C0CF"
              />
            </svg>
          }
        </span>
        <label>{{ option?.label }}</label>
      </div>
    }
  </div>
</div>

<div class="action">
  @if (options?.length) {
    <div
      i18n="@@rate-advanced.clear-selection"
      class="clear-button"
      (click)="clearSelection($event)"
    >
      Clear selection
    </div>
  }
  <div class="action-buttons-container">
    <button
      class="action-buttons"
      (click)="redirect()"
      i18n="@@rate-advanced.go-markup-setting"
    >
      <img src="/assets/media/icons/arrow-square.svg" alt="icon" />
      Go to markup setting
    </button>
    <div
      class="action-buttons-refresh-icon"
      (click)="refreshMarkupOptions()"
      i18n="@@rate-advanced.refresh-markup-setting"
    >
      <img src="/assets/media/icons/wallet/refreshIcon.svg" alt="icon" />
      Refresh list
    </div>
  </div>
</div>
